import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  polls: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.POLL__VOTED:
    case AppConstants.POLL__LOADED: {
      const {cardId, poll} = action.payload;
      return {
        ...state,
        polls: {
          ...state.polls,
          [cardId]: poll,
        },
      };
    }
    default:
      return state;
  }
};
